import { render, staticRenderFns } from "./FullDialog.vue?vue&type=template&id=ca3c8118&"
import script from "./FullDialog.vue?vue&type=script&lang=js&"
export * from "./FullDialog.vue?vue&type=script&lang=js&"
import style0 from "./FullDialog.vue?vue&type=style&index=0&id=ca3c8118&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports